<template>
  <div class="boss-page upload-page">
    <van-nav-bar title="上传公司资料" left-arrow @click-left="$router.back()"/>
    <main>
      <section class="upload-form">
        <div class="source-tabs" role="tablist">
          <button type="button" :class="{active: sourceTab === 'file'}" @click="switchSource('file')">选择文件</button>
          <button type="button" :class="{active: sourceTab === 'voice'}" @click="switchSource('voice')">语音输入</button>
        </div>

        <label v-if="sourceTab === 'file'" class="file-picker" :class="{selected:file}">
          <input ref="fileInput" class="file-input" type="file" :accept="accept" @change="selectFile"/>
          <span class="file-icon"><van-icon :name="file ? 'passed' : 'upgrade'"/></span>
          <span><b>{{ file ? file.name : '选择手机中的资料文件' }}</b><small>{{
              file ? fileSize(file.size) : '支持办公文档、图片、文本和 MP4，最大 20MB'
            }}</small></span>
          <van-icon name="arrow"/>
        </label>

        <boss-voice-input v-else v-model="form.content"/>

        <label>资料标题<input v-model.trim="form.title" maxlength="200" placeholder="选择文件后自动填写"/></label>
        <label>资料分类<select v-model="form.category">
          <option v-for="item in categories" :key="item" :value="item">{{ item }}</option>
        </select></label>
        <label>摘要<textarea v-model.trim="form.summary" maxlength="500" placeholder="选填：用一句话说明资料内容"/></label>
        <label>正文 / 使用说明<textarea v-model.trim="form.content" maxlength="3000" placeholder="选填：可补充资料用途、适用场景或阅读要求"/></label>
        <label>标签<input v-model.trim="form.tags" maxlength="300" placeholder="选填，多个标签用逗号分隔"/></label>

        <details>
          <summary>高级设置 <small>关联指标</small></summary>
          <label>关联 KPI<input v-model.trim="form.metricCodes" placeholder="如 recoveredAmount"/></label>
        </details>

        <p class="workflow">
          <van-icon name="shield-o"/>
          上传后直接进入运营待审核队列，审核发布后进入员工检索与智能推荐。
        </p>
        <van-button block icon="upgrade" color="#D32F2F" :loading="uploading" :disabled="!file && !form.content" @click="upload">上传并提交审核
        </van-button>
      </section>

      <section v-if="result" class="success">
        <van-icon name="checked"/>
        <div><b>资料上传成功</b><span>{{ result.originalName }} 已提交运营审核</span></div>
      </section>
    </main>
  </div>
</template>

<script>
/**
 * Boss 上传公司资料至知识库：选文件 multipart 上传，进入运营审核队列。
 */
import coreapi from '@/utils/coreapi';
import BossVoiceInput from '@/components/boss/BossVoiceInput.vue';

export default {
  components: {BossVoiceInput},
  data() {
    return {
      accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.md,.png,.jpg,.jpeg,.mp4',
      categories: ['公司资料', '战略资料', '制度规范', '业务资料', '培训资料', '销售赋能', '专业技能'],
      file: null,
      sourceTab: 'file',
      uploading: false,
      result: null,
      form: {
        title: '',
        category: this.$route.query.category === '战略资料' ? '战略资料' : '公司资料',
        summary: '',
        content: '',
        tags: '',
        metricCodes: ''
      }
    };
  },
  methods: {
    switchSource(tab) {
      this.sourceTab = tab;
      if (tab === 'voice') {
        this.file = null;
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      }
    },
    selectFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      if (file.size > 20 * 1024 * 1024) {
        event.target.value = '';
        return this.$toast('单个文件不能超过 20MB');
      }
      this.file = file;
      if (!this.form.title) this.form.title = file.name.replace(/\.[^.]+$/, '');
      this.result = null;
    },
    fileSize(value) {
      const mb = value / 1024 / 1024;
      return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(value / 1024))} KB`;
    },
    async upload() {
      if (!this.file && !this.form.content) return this.$toast('请选择资料文件或使用语音生成正文');
      if (!this.form.title) return this.$toast('请填写资料标题');
      this.uploading = true;
      try {
        const data = new FormData();
        const uploadFile = this.file || new File([this.form.content], `${this.form.title}.txt`, {type: 'text/plain;charset=utf-8'});
        data.append('file', uploadFile);
        Object.keys(this.form).forEach(key => data.append(key, this.form[key] || ''));
        this.result = await coreapi.uploadBossKnowledge(data);
        this.$toast.success('资料已上传，等待运营审核');
        this.file = null;
        this.sourceTab = 'file';
        this.form = {title: '', category: '公司资料', summary: '', content: '', tags: '', metricCodes: ''};
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import './boss.less';

.upload-page /deep/ .van-nav-bar {
  overflow: hidden;
  border-radius: .2rem .2rem 0 0
}

.upload-page main {
  padding: .28rem
}

.upload-form {
  padding: .32rem;
  background: #fff;
  border-radius: .24rem;
  box-shadow: 0 .08rem .3rem rgba(211, 47, 47, .1)
}

.file-input {
  display: none
}

.file-picker {
  width: 100%;
  min-height: 1.35rem;
  padding: .22rem;
  display: flex;
  align-items: center;
  text-align: left;
  border: 1PX dashed #cfd1e8;
  border-radius: .18rem;
  background: #fafaff
}

.file-picker.selected {
  border-style: solid;
  border-color: #b9bcea;
  background: #f5f5ff
}

.file-icon {
  width: .76rem;
  height: .76rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 .76rem;
  color: @color;
  border-radius: .16rem;
  background: #eceeff;
  font-size: .4rem
}

.file-picker > span:nth-of-type(2) {
  min-width: 0;
  margin-left: .18rem;
  flex: 1
}

.file-picker b, .file-picker small {
  display: block
}

.file-picker b {
  overflow: hidden;
  color: #34364a;
  font-size: .29rem;
  text-overflow: ellipsis;
  white-space: nowrap
}

.file-picker small {
  margin-top: .06rem;
  color: #9295a7;
  font-size: .22rem;
  line-height: 1.4
}

.file-picker > .van-icon {
  margin-left: .12rem;
  color: #aaa;
  font-size: .28rem
}

.source-tabs {
  display: flex;
  margin-bottom: .22rem;
  padding: .08rem;
  background: #f5f6fb;
  border-radius: .16rem
}

.source-tabs button {
  height: .7rem;
  flex: 1;
  color: #74778c;
  font-size: .28rem;
  border: 0;
  border-radius: .12rem;
  background: transparent
}

.source-tabs button.active {
  color: #fff;
  background: @color;
  box-shadow: 0 .05rem .14rem rgba(211, 47, 47, .2)
}

.upload-form label {
  display: block;
  margin-top: .24rem;
  color: #55586b;
  font-size: .26rem
}

.upload-form input, .upload-form select, .upload-form textarea {
  width: 100%;
  margin-top: .1rem;
  padding: .2rem;
  border: 1PX solid #e2e3ec;
  border-radius: .12rem;
  background: #fafaff;
  font-size: .28rem;
  box-sizing: border-box
}

.upload-form textarea {
  height: 1.15rem;
  resize: none
}

.upload-form select {
  height: .78rem;
  color: #34364a
}

details {
  margin: .24rem 0;
  padding: .18rem .2rem;
  border-radius: .14rem;
  background: #f7f7fb
}

summary {
  color: @color;
  font-size: .27rem;
  cursor: pointer
}

summary small {
  margin-left: .08rem;
  color: #999;
  font-size: .22rem
}

.workflow {
  margin: .22rem 0;
  display: flex;
  align-items: flex-start;
  color: #7c7f91;
  font-size: .23rem;
  line-height: 1.5
}

.workflow .van-icon {
  margin: .03rem .1rem 0 0;
  color: @color;
  font-size: .28rem
}

.upload-form > .van-button {
  height: .86rem;
  border-radius: .14rem;
  font-size: .3rem;
  box-shadow: 0 .08rem .2rem rgba(211, 47, 47, .2)
}

.success {
  margin-top: .2rem;
  padding: .25rem;
  display: flex;
  align-items: center;
  color: #278653;
  background: #e8f7ef;
  border-radius: .18rem
}

.success > .van-icon {
  margin-right: .18rem;
  font-size: .46rem
}

.success b, .success span {
  display: block
}

.success b {
  font-size: .3rem
}

.success span {
  margin-top: .05rem;
  color: #56806a;
  font-size: .23rem
}

.upload-form > .file-picker {
  display: flex;
  min-height: 1.35rem;
  margin-top: 0
}

.file-picker {
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden
}

.file-picker .file-input {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer
}

.file-picker > .file-icon {
  min-width: .76rem;
  margin-left: 0;
  flex: 0 0 .76rem
}

.file-picker > span:nth-of-type(2) {
  min-width: 0;
  margin-left: .18rem;
  flex: 1
}
</style>



// WEBPACK FOOTER //
// src/views/boss/KnowledgeUpload.vue